<script setup>
import Footer from '@/views/front-pages/front-page-footer.vue'
import Navbar from '@/views/front-pages/front-page-navbar.vue'
import { useTitle } from '@vueuse/core'
import axios from '@/helpers/axios'
import moment from "moment";
import Breadcrumbs from '@/views/general/Breadcrumbs.vue'
import { useI18n } from 'vue-i18n'

definePage({ meta: { layout: 'blank', public: true } })

const articleData = ref(null)

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const slug = route.params.slug


const bread = ref([])

const getPost = () => {
  axios.get('/blog/' + slug).then(response => {
    articleData.value = response.data
    useTitle(articleData.value.title + ' - Kropie')
    track(articleData.value.slug)
  }).catch(e => {
    console.error(e)
    router.replace({ name: 'blog' })
  })
}

const track = (slug) => {
  axios.get('/blog/' + slug + '/track')
}

getPost()



watchEffect(() => {
  bread.value = [
    {
      text: t('blog.articles'),
      link: { name: 'webcams' }
    },
    {
      text: articleData.value ? articleData.value.title : '...'
    }
  ]
})
</script>

<template>
  <div class="bg-surface">
    <!-- 👉 Navbar  -->
    <Navbar />

    <!-- 👉 Content -->
    <VContainer v-if="articleData"  class="mb-16">
      <br>
      <VRow class="mt-16">

        <VCol cols="12">
          <Breadcrumbs :items="bread"/>

          <div>
            <h4 class="text-h4 mb-2">
              {{ articleData?.title }}
            </h4>

            <div class="text-sm" v-if="articleData.created_at">
              {{ moment.utc(articleData.created_at).local().format("Y-MM-DD HH:mm") }}
            </div>
          </div>

          <VDivider class="my-8" />

          <!-- eslint-disable vue/no-v-html -->
          <div
            class="mb-8"
            v-html="articleData?.content"
          />

        </VCol>

      </VRow>
    </VContainer>

    <!-- 👉 Footer  -->
    <Footer class="mt-15" />
  </div>
</template>

<style lang="scss" scoped>
.card-list {
  --v-card-list-gap: 1rem;
}
</style>

<style lang="scss">
.v-breadcrumbs{
  .v-breadcrumbs-item{
    padding: 0 !important;
  }
}

.mb-8 img {
  max-width: 100%; /* Ensure images don't exceed container width */
  height: auto; /* Maintain aspect ratio */
}
</style>